import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { IntlProvider } from "react-intl";
import useAppStore from "stores/AppStore";
import useCustomConfig from "hooks/useConfig";
import messages from "translations/messages_en.json";

function SwappingIntlProvider({ children }) {
  const selectedLanguage = useAppStore((state) => state.selectedLanguage);
  const setSelectedLanguage = useAppStore((state) => state.setSelectedLanguage);
  const config = useCustomConfig();
  const [translations, setTranslations] = useState(messages);

  // Update language if a default language is available o app config
  useEffect(() => {
    if (config && config.ui && config.ui.language) {
      // If there is a specific language set on the configuration for the environment, use that one (for the use case of North Macedonia)
      setSelectedLanguage(config.ui.language);
    }
  }, [config, setSelectedLanguage]);

  // Update language if a new language is selected
  useEffect(() => {
    let selectedCleanLanguage = selectedLanguage;
    if (selectedCleanLanguage.length > 2) {
      selectedCleanLanguage = selectedCleanLanguage.substring(0, 2);
    }

    // English is already bundled via the static import above — reuse it
    // instead of downloading the same ~220 KB catalogue again as a chunk.
    if (selectedCleanLanguage === "en") {
      setTranslations(messages);
      return;
    }

    import(`translations/messages_${selectedCleanLanguage}.json`)
      // Unwrap the module namespace: message ids with dots in them are only
      // present on `default`, not as named exports.
      .then((m) => setTranslations(m.default ?? m))
      .catch(() => {
        console.warn(
          `Translations for ${selectedCleanLanguage} not found. Using default messages.`,
          setTranslations(messages),
        );
      });
  }, [selectedLanguage]);

  return (
    <IntlProvider locale={selectedLanguage} messages={translations}>
      {children}
    </IntlProvider>
  );
}

SwappingIntlProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SwappingIntlProvider;
